import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function toTitleCase(value) {
  if (!value) return "";
  return value
    .toLocaleLowerCase("es")
    .replace(/\p{L}+/gu, (word) => {
      const first = word.charAt(0).toLocaleUpperCase("es");
      return `${first}${word.slice(1)}`;
    });
}
